<!-- 关联获客链接弹窗组件 -->
<template>
  <div>
    <div>
      <el-input
        v-model="queryParams.keywords"
        style="width:300px;"
        placeholder="请输入"
      />
      <el-select
        v-model="queryParams.onlyMe"
        :disabled="true"
        placeholder="请选择"
        style="width:300px;margin: 0 10px;"
      >
        <el-option
          v-for="item in accountarr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-select
        v-model="queryParams.default_a"
        placeholder="请选择"
        style="width:300px;margin-right: 10px;"
      >
        <el-option
          v-for="item in defaultarr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="sraw"
      >搜索</el-button>
      <el-button
        type="info"
        icon="el-icon-refresh-right"
        @click="awered"
      >重置</el-button>
    </div>
    <div class="choses_box">
      <div
        class="select_box"
        :class="[isAllSelected ? 'choose_blockr' : '']"
        @click="handleSelectAllClick"
      />
      <div
        v-if="isAllSelected"
        @click="handleSelectAllClick"
      >
        取消全选
      </div>
      <div
        v-else
        @click="handleSelectAllClick"
      >
        全选
      </div>
    </div>
    <el-table
      ref="table"
      :data="tableData"
      style="width: 100%"
      row-key="id"
      max-height="500"
    >
      <el-table-column
        label=""
        width="55"
      >
        <template slot="header">
          <!-- <div class="choses_box">
            <div
              class="select_box"
              :class="[isAllSelected ? 'choose_blockr' : '']"
              @click="handleSelectAllClick"
            />
            <div
              v-if="isAllSelected"
              @click="handleSelectAllClick"
            >
              取消全选
            </div>
            <div
              v-else
              @click="handleSelectAllClick"
            >
              全选
            </div>
          </div> -->
        </template>
        <template slot-scope="scope">
          <el-checkbox
            :value="scope.row.tips"
            :disabled="scope.row.id === disabledId"
            @input="(val) => handleCheckboxChange(scope.row, val)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        width="200"
        align="center"
      />
      <el-table-column
        prop="iqiyi_promotion_link_no"
        label="编号"
        width="400"
        align="center"
      />
      <el-table-column
        prop="app_id"
        label="小程序appid"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.app_id }} ({{ scope.row.account_name || '' }})
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 15px; color: #666;">
      已关联{{ selectedItems.length }}条获客链接
    </div>
    <pagination-right
      style="padding:0px;margin-top:20px"
      :total="total"
      :current-page="queryParams.page"
      :page-size="queryParams.pageSize"
      :page-sizes="[10, 20, 50]"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { iqiyipromotionlinklist } from '@/api/officialaccount.js'

export default {
  name: 'LinkCustomerAcquisition',
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: [],
      selectedItems: [], // 已选中的项 [{id, title}]
      total: 0,
      queryParams: {
        page: 1,
        pageSize: 10,
        keywords: '',
        default_a: 0,
        onlyMe: 2
      },
      accountarr: [
        {
          value: 1,
          label: '查看组内推广链接'
        },
        {
          value: 2,
          label: '我关联的推广链接'
        }
      ],
      defaultarr: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '非默认页面'
        },
        {
          value: 2,
          label: '默认页'
        }
      ],
      selectedIds: [], // 使用数组存储选中的 id，确保响应式
      disabledId: null, // 需要禁用的 id（编辑时传入，不能选择自己）
      wechatid: ''
    }
  },
  computed: {
    // 判断当前页是否全部选中（模仿你的判断逻辑）
    isAllSelected() {
      // 如果当前页没有数据，返回 false
      if (!this.tableData || this.tableData.length === 0) {
        return false
      }

      // 过滤掉被禁用的项（编辑时不能选择自己）
      const selectableItems = this.tableData.filter((item) => {
        return item.id !== this.disabledId
      })

      // 如果没有可选项，返回 false
      if (selectableItems.length === 0) {
        return false
      }

      // 检查所有可选项是否都被选中
      return selectableItems.every((item) => {
        // 检查该项的 tips 属性是否为 true（对应你的 item.tips === true）
        // 使用 == 而不是 ===，因为 tips 可能是 undefined
        // eslint-disable-next-line eqeqeq
        return item.tips == true
      })
    },
    // 判断是否为半选状态（部分选中）
    isIndeterminate() {
      if (!this.tableData || this.tableData.length === 0) {
        return false
      }
      const selectedCount = this.tableData.filter((item) => {
        return this.selectedIds.includes(item.id)
      }).length
      return selectedCount > 0 && selectedCount < this.tableData.length
    }
  },
  mounted() {
    // 不在 mounted 时自动加载,等待父组件调用 initSelected
  },
  methods: {
    // 获取列表数据
    async getList() {
      try {
        const data = await iqiyipromotionlinklist({ ...this.queryParams, type: 2, app_id: this.wechatid })
        const list = data.data.list || []
        // 给每行数据添加 tips 属性（选中状态）
        this.tableData = list.map(row => {
          // 检查该行是否在 selectedIds 中，如果在则设置为 true，否则为 false
          const isSelected = this.selectedIds.includes(row.id)
          return {
            ...row,
            tips: isSelected
          }
        })
        this.total = data.data.total || 0

        // 补充 selectedItems 中缺少的 iqiyi_promotion_link_no 字段
        this.selectedItems.forEach(selectedItem => {
          if (!selectedItem.iqiyi_promotion_link_no) {
            // 从当前页的 tableData 中查找
            const foundRow = this.tableData.find(row => row.id === selectedItem.id)
            if (foundRow && foundRow.iqiyi_promotion_link_no) {
              selectedItem.iqiyi_promotion_link_no = foundRow.iqiyi_promotion_link_no
            }
          }
        })
      } catch (error) {
        console.error('获取获客链接列表失败:', error)
        this.$message.error('获取列表失败')
      }
    },

    // 处理复选框变化
    handleCheckboxChange(row, checked) {
      // 如果该项被禁用，不允许操作
      if (row.id === this.disabledId) {
        return
      }

      // 更新行的 tips 属性（使用 $set 确保响应式）
      this.$set(row, 'tips', checked)

      if (checked) {
        // 选中：添加到 selectedIds 和 selectedItems
        if (!this.selectedIds.includes(row.id)) {
          this.selectedIds.push(row.id)
        }
        const index = this.selectedItems.findIndex(item => item.id === row.id)
        if (index === -1) {
          this.selectedItems.push({
            id: row.id,
            title: row.title,
            iqiyi_promotion_link_no: row.iqiyi_promotion_link_no
          })
        }
      } else {
        // 取消选中：从 selectedIds 和 selectedItems 中移除
        const idIndex = this.selectedIds.indexOf(row.id)
        if (idIndex !== -1) {
          this.selectedIds.splice(idIndex, 1)
        }
        const itemIndex = this.selectedItems.findIndex(item => item.id === row.id)
        if (itemIndex !== -1) {
          this.selectedItems.splice(itemIndex, 1)
        }
      }

      // 强制更新视图，确保计算属性重新计算
      this.$forceUpdate()
    },

    // 处理全选点击
    handleSelectAllClick() {
      const shouldSelect = !this.isAllSelected
      // 更新当前页所有行的 tips 属性（排除被禁用的项）
      this.tableData.forEach(row => {
        // 跳过被禁用的项
        if (row.id === this.disabledId) {
          return
        }

        this.$set(row, 'tips', shouldSelect)

        if (shouldSelect) {
          // 全选：添加到 selectedIds 和 selectedItems
          if (!this.selectedIds.includes(row.id)) {
            this.selectedIds.push(row.id)
          }
          const index = this.selectedItems.findIndex(item => item.id === row.id)
          if (index === -1) {
            this.selectedItems.push({
              id: row.id,
              title: row.title,
              iqiyi_promotion_link_no: row.iqiyi_promotion_link_no
            })
          }
        } else {
          // 取消全选：从 selectedIds 和 selectedItems 中移除
          const idIndex = this.selectedIds.indexOf(row.id)
          if (idIndex !== -1) {
            this.selectedIds.splice(idIndex, 1)
          }
          const itemIndex = this.selectedItems.findIndex(item => item.id === row.id)
          if (itemIndex !== -1) {
            this.selectedItems.splice(itemIndex, 1)
          }
        }
      })

      // 强制更新视图，确保计算属性重新计算
      this.$forceUpdate()
    },

    // 分页大小变化
    handleSizeChange(size) {
      this.queryParams.pageSize = size
      this.queryParams.page = 1
      this.getList()
    },

    // 当前页变化
    handleCurrentChange(page) {
      this.queryParams.page = page
      this.getList()
    },

    // 初始化选中的项（从父组件传入）
    initSelected(selectedItems, disabledId = null, wechatid) {
      // 深拷贝避免引用问题
      this.selectedItems = selectedItems ? JSON.parse(JSON.stringify(selectedItems)) : []
      // 更新 selectedIds 数组
      this.selectedIds = this.selectedItems.map(item => item.id)
      // 设置需要禁用的 id
      console.log('1111', disabledId)
      this.disabledId = disabledId
      this.wechatid = wechatid
      this.getList()
    },

    // 获取选中的项
    getSelectedItems() {
      // 确保返回的数据包含 iqiyi_promotion_link_no 字段
      return this.selectedItems.map(item => {
        // 如果缺少 iqiyi_promotion_link_no，尝试从 tableData 中查找
        if (!item.iqiyi_promotion_link_no) {
          const foundRow = this.tableData.find(row => row.id === item.id)
          if (foundRow && foundRow.iqiyi_promotion_link_no) {
            return {
              ...item,
              iqiyi_promotion_link_no: foundRow.iqiyi_promotion_link_no
            }
          }
        }
        return item
      })
    },
    sraw() {
      this.queryParams.page = 1
      this.getList()
    },
    awered() {
      this.queryParams.page = 1
      this.queryParams.keywords = ''
      this.queryParams.onlyMe = 2
      this.queryParams.default_a = 0
      this.getList()
    }
  }
}
</script>

<style scoped>
.choses_box {
  display: flex !important;
  align-items: center !important;
  cursor: pointer !important;
  margin-bottom: 0 !important;
  margin-left: 10px;
  margin-top: 20px;
}

.select_box {
  height: 14px !important;
  width: 14px !important;
  border-radius: 3px !important;
  border: 1px solid skyblue !important;
  margin-right: 7px !important;
  cursor: pointer !important;
  flex-shrink: 0 !important;
  box-sizing: border-box !important;
  display: inline-block !important;
}

.choose_blockr {
  background: #409eff !important;
  border-color: #409eff !important;
}

.choses_box > div:not(.select_box) {
  cursor: pointer !important;
  user-select: none !important;
  font-size: 14px !important;
  color: #333 !important;
  white-space: nowrap !important;
  line-height: 1 !important;
}
</style>

